import React from 'react';
import { ArrowRight, Radio } from 'lucide-react';
import '../styles/Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProject = () => {
    const element = document.getElementById('project');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <div className="hero-badge">
          <Radio size={16} />
          <span>Pasif Radar Teknolojisi</span>
        </div>
        
        <h1 className="hero-title display-huge">
          Geleceğin Radar Teknolojisi
          <span className="hero-highlight"> Revera</span>
        </h1>
        
        <p className="hero-description body-large">
          Pasif radar sistemleri ile havacılık ve savunma sanayi için yenilikçi, 
          maliyet etkin ve gizli algılama çözümleri geliştiriyoruz.
        </p>
        
        <div className="hero-buttons">
          <button className="btn-primary" onClick={scrollToProject}>
            Projeyi Keşfet
            <ArrowRight size={20} />
          </button>
          <button className="btn-secondary" onClick={scrollToContact}>
            İletişime Geç
          </button>
        </div>
        
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">4</div>
            <div className="stat-label body-muted">Uzman Ekip</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">1</div>
            <div className="stat-label body-muted">Yenilikçi Teknoloji</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">∞</div>
            <div className="stat-label body-muted">Potansiyel</div>
          </div>
        </div>
      </div>
      
      <div className="hero-grid-overlay"></div>
    </section>
  );
};

export default Hero;
